export function getRecordType(record) {
  return record?.constructor?.modelName ?? record?.recordType ?? 'unknown';
}
